import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type DeleteButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const DeleteButton = ({
    label = "Delete",
    loadingText = "Deleting...",
    buttonType = "button",
    variant = "destructive",
    ...props
}: DeleteButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="delete"
            testId="delete-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default DeleteButton;
